export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_COUNTRY = 'SET_COUNTRY';
export const ADD_COUNTRY = 'ADD_COUNTRY';
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
export const REMOVE_COUNTRY = 'REMOVE_COUNTRY';
export const CLEAR_COUNTRY = 'CLEAR_COUNTRY';
export const CLEAR_COUNTRIES = 'CLEAR_COUNTRIES';
